import Button from '@material-ui/core/Button';
import React from 'react';
import { NavLink } from 'react-router-dom';
import strings from './language/language';
import { withStyles } from '@material-ui/core/styles';
import ReactPixel from 'react-facebook-pixel';

const styles = (theme) => ({
  addToBasket: {
    color: '#fff',
    fontSize: 16,
    height: 55,
    textTransform: 'capitalize',
    borderRadius: 28,
    bottom: -15,
    margin: 'auto',
    maxWidth: '90%',
    width: '100%',
    boxShadow: 'none',
    textTransform: 'capitalize',
    left: 0,
    right: 0,
  },
});
const SubmitButton = (props) => {
  const { classes } = props;
  return (
    <div
      onClick={() => {
        if (props.cart.length === 0) {
          ReactPixel.trackCustom(
            `desktop - ${props.restaurant_name} - Add to Basket`,
            {
              userID: props.messenger_user_id,
            }
          );
          ReactPixel.trackCustom('desktop - Add to Basket');
        }
      }}
      className='fixed-button-placeholder'
      title='Add To Basket'
    >
      <NavLink to='/order' style={{ textDecoration: 'none', color: 'inherit' }}>
        <Button
          className={classes.addToBasket}
          style={{
            backgroundColor: props.color ? props.color : '#70142c',
            border: `1px solid ${props.color}`,
          }}
          onClick={props.click}
          title='Add to Basket'
        >
          {strings.add_to_basket}
        </Button>
      </NavLink>
    </div>
  );
};
export default withStyles(styles)(SubmitButton);



// WEBPACK FOOTER //
// ./src/components/SubmitButton.js